<template>
  <div id="app">
    <newHeader></newHeader>
    <div id="container">
      <router-view />
    </div>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style scoped>
#container {
  min-height: 100vh;
  /* overflow-x: hidden; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue